import * as yup from 'yup';

const getInvalidDateMessage = ({ label }) => `${label} should be a valid date.`;

export const longTermCalculationScheme = yup.object().shape({
  startDate: yup
    .date()
    .required()
    .typeError(getInvalidDateMessage)
    .label('From'),
  endDate: yup
    .date()
    .required()
    .typeError(getInvalidDateMessage)
    .label('Till'),
});

export const dailyCalculationScheme = yup.object().shape({
  startDate: yup
    .date()
    .required()
    .typeError(getInvalidDateMessage)
    .label('From'),
});